import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/NavBar';
import './NotFound.css';

function NotFound() {
  return (
    <div>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Page Not Found - Logic Puzzles CA</title>
      </Helmet>
      <NavBar />
      <div className="not-found-page">
        <div className="container not-found-inner">
          <span className="eyebrow">Error</span>
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>Oops! The page you're looking for doesn't exist.</p>
          <div className="not-found-actions">
            <Link to="/" className="button">
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;